/**
 * ContentSwitcher.jsx
 * Created by Destin Frasier on 7/24/17.
 */

import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    options: PropTypes.array,
    activeIndex: PropTypes.number,
    children: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.element
    ]),
    handleClick: PropTypes.func,
    disabled: PropTypes.bool
};

const defaultProps = {
    options: [],
    children: [],
    activeIndex: 0,
    handleClick() { }
};

export default class ContentSwitcher extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            activeIndex: this.props.activeIndex
        };

        this._generateOptions = this._generateOptions.bind(this);
        this._renderPanels = this._renderPanels.bind(this);
        this.handleOptionClick = this.handleOptionClick.bind(this);
    }

    componentDidUpdate(prevProps) {
        const { activeIndex } = this.props;

        if (activeIndex !== prevProps.activeIndex && activeIndex !== this.state.activeIndex) {
            this.setState({ activeIndex });
        }
    }

    handleOptionClick(e, activeIndex) {
        e.preventDefault();
        this.setState({
            activeIndex
        }, () => {
            this.props.handleClick(activeIndex);
        });
    }

    _generateOptions() {
        return this.props.options.map((option, index) => {
            const activeClass = index === this.state.activeIndex ? 'active' : '';
            const selected = index === this.state.activeIndex;

            return (
                <li
                    className={activeClass}
                    role="presentation"
                    data-value={option.value}
                    key={option.label}>
                    <button
                        role="tab"
                        aria-selected={selected}
                        disabled={this.props.disabled}
                        onClick={(event) => this.handleOptionClick(event, index)}>
                        {option.label}
                    </button>
                </li>
            );
        });
    }

    _renderPanels() {
        return this.props.children
            .map((child, index) => {
                const tabID = index;
                const selected = tabID === this.state.activeIndex;

                let hidden = 'hide';
                if (selected) {
                    hidden = '';
                }

                return (
                    <div
                        {...child.props}
                        key={`tab-panel-${tabID}`}
                        role="tabpanel"
                        aria-hidden={!selected}
                        className={hidden}>
                        {child.props.children}
                    </div>
                );
            });
    }

    render() {
        const content = this._generateOptions();
        const panels = this._renderPanels();

        return (
            <div>
                <ul
                    className="rec-content-switcher"
                    role="tablist">
                    {content}
                </ul>
                <section
                    className="rec-content-panel"
                    role="tabpanel">
                    {panels}
                </section>
            </div>
        );
    }
}

ContentSwitcher.propTypes = propTypes;
ContentSwitcher.defaultProps = defaultProps;
